// extracted by mini-css-extract-plugin
export default {"SponsorList":"SponsorshipPages_SponsorList__LKFaq","List":"SponsorshipPages_List__cSQYY"};